// extracted by mini-css-extract-plugin
module.exports = {"ReadMore":"Feedback_ReadMore__1-Aq6"};